<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.64282 12.75V11.25H18.6428V12.75H5.64282Z" fill="currentColor"/>
</svg>
